<template>
  <div class="time-selector">
    <div class="time-selector__content">
      <div class="time-selector__value is-flex is-align-items-center">
        <span class="time-selector__icon is-size-4">
          <n-tooltip text="Set the date and time to use in the preview tool" position="top">
            <font-awesome-icon :icon="['far', 'clock']" />
          </n-tooltip>
        </span>
        <EditableComponent
          type="datetime-local"
          v-model="selectedDate"
          @input="handleDateChange"
          :options="[]"
          fieldName="Current Time"
          :displayRelativeDate="false"
          :displayIcon="true"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import EditableComponent from '@/shared/components/EditableComponent.vue';
import { useVModel } from '@vueuse/core';

const props = defineProps({
  modelValue: {
    type: Date,
    required: true,
  },
});
const emit = defineEmits<{
  (e: 'update:modelValue', value: Date): void;
}>();

const selectedDate = useVModel(props, 'modelValue', emit);

function handleDateChange(date: Date) {
  selectedDate.value = date;
}
</script>

<style lang="scss" scoped>
.time-selector {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  padding: 0.25rem;
  position: relative;
  &__content {
    padding: 1rem 0;
  }
  &__value {
    user-select: none;
  }
  &__icon {
    width: 4rem;
    text-align: center;
    color: $color-netcall-salmon;
  }
  :deep(.editable-component) {
    cursor: text;
    height: auto;
  }
  :deep(.editable-component__write-view) {
    input {
      font-size: 1rem;
    }
  }
}
</style>
